export default "__VITE_ASSET__Dx2$Rcn6__"